import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import {
  ExpandMore as ExpandMoreIcon,
  BorderColorTwoTone as BorderColorTwoToneIcon,
} from "@mui/icons-material";
import { useParams } from "react-router-dom";
import { styled } from "@mui/material/styles";
import Divider from "@mui/material/Divider";
import Chip from "@mui/material/Chip";
import { GLOBAL_URL } from "../../../API/global";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { calculateAge, convertDateToIndianFormat } from "../../Helper";
import { getRequestGlobal } from "../../../API/global";
import { getRequest } from "../../../API/IP";

const Root = styled("div")(({ theme }) => ({
  width: "100%",
  margin: "10px",
  color: theme.palette.text.secondary,
  "& > :not(style) ~ :not(style)": {
    marginTop: theme.spacing(2),
  },
}));

const Preview = ({ formData, setActiveStep }) => {
  const [age] = useState(calculateAge(formData.dob) || "");
  const [city, setCity] = useState({});
  const [residencecity, setResidencecity] = useState({});
  const [state, setState] = useState({});
  const [craftData, setCraftData] = useState([]);
  const [qualification, setQualification] = useState({});

  const { id = null } = useParams();
  const loadQualification = () => {
    getRequestGlobal("qualification")
      .then((data) => {
        // console.log("Qualification Data:", data.data); // Check what data is being returned
        setQualification(data.data); // Set the qualification state
      })
      .catch((error) => {
        console.error("Error loading qualification data:", error);
      });
  };

  useEffect(() => {
    const loadData = async () => {
      getRequestGlobal("state", {})
        .then((data) => {
          setState(data.data);
          if (formData.permanent_state) {
            loadpermanentCity(formData.permanent_state);
          }
          if (formData.residence_state) {
            loadresidenceCity(formData.residence_state);
          }
        })
        .catch((error) => {
          console.error("Fetch error:", error);
        });
    };
    loadpreData();
    loadData();
    loadQualification();
  }, []);

  const loadpreData = async () => {
    const data = {};
    try {
      const predata = await getRequest(`craft`, {});
      if (predata.status && predata.data.length) {
        for (const craft of predata.data) {
          data[craft.id] = craft.name;
        }
        setCraftData(data);
      }
    } catch (error) {}
  };
  const loadpermanentCity = (state_id) => {
    // console.log({ state_id })
    getRequestGlobal("city", { state_id })
      .then((data) => {
        setCity(data.data);
      })
      .catch((error) => {});
  };
  const loadresidenceCity = (state_id) => {
    getRequestGlobal("city", { state_id })
      .then((data) => {
        setResidencecity(data.data);
      })
      .catch((error) => {});
  };

  // Handler to redirect to a specific step
  const handleRedirectStep = (value) => setActiveStep(value);
  const [expanded, setExpanded] = React.useState("panel1");
  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };
  return (
    <>
      <div className="cmot-phone">
        <h5>STEP 4</h5>
        Preview
      </div>
      <div className="container mt-5">
        {/* Accordion for Personal Detail */}
        <Accordion
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1-content"
            id="panel1-header"
          >
            <button
              onClick={() => handleRedirectStep(0)}
              style={{
                background: "transparent",
                border: "none",
                marginRight: "20px",
                color: "#1c5768",
              }}
            >
              <BorderColorTwoToneIcon />
            </button>
            Personal Detail
          </AccordionSummary>
          <AccordionDetails>
            <Container maxWidth="lg">
              <div className="row">
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield">Full Name : </span>
                    <span className="inputoffield"> {formData.name}</span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield">Date of Birth :</span>
                    <span className="inputoffield">
                      {" "}
                      {convertDateToIndianFormat(formData.dob)}
                    </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield">Age :</span>
                    <span className="inputoffield"> {age}</span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield">Gender :</span>
                    <span className="inputoffield">
                      {" "}
                      {formData.gender || ""}
                    </span>
                  </p>
                </div>
                {formData.gender == "Other" ? (
                  <>
                    <div className="col-md-6">
                      <p>
                        <span className="titleoffield">Other Gender :</span>
                        <span className="inputoffield">
                          {" "}
                          {formData.other_gender || ""}
                        </span>
                      </p>
                    </div>
                  </>
                ) : (
                  <></>
                )}
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield">
                      (+ Country Code) - Mobile Number :
                    </span>
                    <span className="inputoffield">
                      {" "}
                      {formData.country_code + " " + formData.contact_number}
                    </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield">Email ID :</span>
                    <span className="inputoffield"> {formData.email}</span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield">Photo :</span>
                    <span className="inputoffield">
                      <a
                        href={`${GLOBAL_URL}downloadfile/cmot/${formData.id}/${formData?.documentData?.[5]?.file}`}
                      >
                        {formData?.documentData?.[5]?.name}
                      </a>
                    </span>
                  </p>
                </div>

                {formData.highest_qualification_id && (
                  <div className="col-md-12">
                    <p>
                      <span className="titleoffield">
                        Highest Qualification :
                      </span>
                      <span className="inputoffield">
                        {qualification[formData.highest_qualification_id]}
                      </span>
                    </p>
                  </div>
                )}

                {formData.degree && (
                  <div className="col-md-12">
                    <p>
                      <span className="titleoffield">Name of Degree :</span>
                      <span className="inputoffield">{formData.degree}</span>
                    </p>
                  </div>
                )}

                {formData.year_of_degree && (
                  <div className="col-md-12">
                    <p>
                      <span className="titleoffield">Year of Passing :</span>
                      <span className="inputoffield">
                        {formData.year_of_degree}
                      </span>
                    </p>
                  </div>
                )}

                <div className="col-md-12">
                  <p>
                    <span className="titleoffield">
                      Applicant Brief Bio (Not exceed 200 words) :
                    </span>
                    <span className="inputoffield"> {formData.bio}</span>
                  </p>
                </div>
                <div className="col-md-12">
                  <p>
                    <span className="titleoffield">
                      Why Do You Want To Participate In The Program ? :
                    </span>
                    <span className="inputoffield">
                      {" "}
                      {formData.reason_to_join}
                    </span>
                  </p>
                </div>
                <div className="col-md-12">
                  <p>
                    <span className="titleoffield">
                      Describe a time when you helped your team succeed while
                      also building relationships with new people. (Not exceed
                      200 words) :
                    </span>
                    <span className="inputoffield"> {formData.bio2}</span>
                  </p>
                </div>
                <div className="col-md-12">
                  <p>
                    <span className="titleoffield">
                      How do you rate yourself as a team player? (1 being the
                      lowest, 10 being the highest) :
                    </span>
                    <span className="inputoffield"> {formData.scale}</span>
                  </p>
                </div>
                {/* <Root>
                  <Divider>
                    <Chip label="Optional" size="small" />
                  </Divider>
                </Root> */}
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield">
                      (+ Country Code) - Alternate Number :
                    </span>
                    <span className="inputoffield">
                      {" "}
                      {formData.alternate_country_code +
                        " " +
                        formData.alternate_number}
                    </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield">Website Link :</span>
                    <span className="inputoffield">
                      {" "}
                      {formData.website_link}
                    </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield">
                      Twitter (Account Link) :
                    </span>
                    <span className="inputoffield">
                      {" "}
                      {formData.twitter_account_link}
                    </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield">
                      Instagram (Account Link) :
                    </span>
                    <span className="inputoffield">
                      {" "}
                      {formData.instagram_account_link}
                    </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield">
                      Facebook (Account Link) :
                    </span>
                    <span className="inputoffield">
                      {" "}
                      {formData.facebook_account_link}
                    </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield">
                      LinkedIn (Account Link) :
                    </span>
                    <span className="inputoffield">
                      {" "}
                      {formData.linkedin_account_link}
                    </span>
                  </p>
                </div>
                <div className="col-md-12">
                  <p>
                    <span className="titleoffield">
                      How Did You Find About CMOT? :
                    </span>
                    <span className="inputoffield">
                      {" "}
                      {formData.how_you_find}
                    </span>
                  </p>
                </div>
              </div>
            </Container>
          </AccordionDetails>
        </Accordion>

        {/* Accordion for Address Identification */}
        <Accordion
          expanded={expanded === "panel2"}
          onChange={handleChange("panel2")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2-content"
            id="panel2-header"
          >
            <button
              onClick={() => handleRedirectStep(1)}
              style={{
                background: "transparent",
                border: "none",
                marginRight: "20px",
                color: "#1c5768",
              }}
            >
              <BorderColorTwoToneIcon />
            </button>
            Address Identification
          </AccordionSummary>
          <AccordionDetails>
            <Container maxWidth="lg">
              <div className="row">
                <div className="col-md-12">
                  <p>
                    <span className="titleoffield">Permanent Address : </span>
                    <span className="inputoffield">
                      {" "}
                      {formData.permanent_address}
                    </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield">State/UT : </span>
                    <span className="inputoffield">
                      {" "}
                      {formData.permanent_state
                        ? state?.[formData.permanent_state]
                          ? state[formData.permanent_state]
                          : ""
                        : ""}
                    </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield">City : </span>
                    <span className="inputoffield">
                      {" "}
                      {formData.permanent_city
                        ? city?.[formData.permanent_city]
                          ? city[formData.permanent_city]
                          : ""
                        : ""}
                    </span>
                  </p>
                </div>
                {/* <div className="col-md-6">
                  <p>
                    <span className="titleoffield">State/UT of Origin : </span>
                    <span className="inputoffield">
                      {" "}
                      {formData.state_of_origin_id
                        ? state?.[formData. ]
                          ? state[formData.state_of_origin_id]
                          : ""
                        : ""}
                    </span>
                  </p>
                </div> */}
                {formData.address_confirmation === 0 ? (
                  <>
                    <div className="col-md-12">
                      <p>
                        <span className="titleoffield">
                          Residence Address :{" "}
                        </span>
                        <span className="inputoffield">
                          {" "}
                          {formData.residence_address}
                        </span>
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <span className="titleoffield">State/UT : </span>
                        <span className="inputoffield">
                          {" "}
                          {formData.residence_state
                            ? state?.[formData.residence_state]
                              ? state[formData.residence_state]
                              : ""
                            : ""}
                        </span>
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <span className="titleoffield">City : </span>
                        <span className="inputoffield">
                          {" "}
                          {formData.residence_city
                            ? residencecity?.[formData.residence_city]
                              ? residencecity[formData.residence_city]
                              : ""
                            : ""}
                        </span>
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="col-md-12">
                      <p>
                        <span className="titleoffield">
                          Residence Address :{" "}
                        </span>
                        <span className="inputoffield">
                          {" "}
                          {formData.permanent_address}
                        </span>
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <span className="titleoffield">State/UT : </span>
                        <span className="inputoffield">
                          {" "}
                          {formData.permanent_state
                            ? state?.[formData.permanent_state]
                              ? state[formData.permanent_state]
                              : ""
                            : ""}
                        </span>
                      </p>
                    </div>
                    <div className="col-md-6">
                      <p>
                        <span className="titleoffield">City : </span>
                        <span className="inputoffield">
                          {" "}
                          {formData.permanent_city
                            ? city?.[formData.permanent_city]
                              ? city[formData.permanent_city]
                              : ""
                            : ""}
                        </span>
                      </p>
                    </div>
                  </>
                )}

                <div className="col-md-6">
                  <p>
                    <span className="titleoffield">
                      First Govt. ID Number :{" "}
                    </span>
                    <span className="inputoffield">
                      {" "}
                      {formData.first_govt_id_number}
                    </span>
                  </p>
                </div>

                <div className="col-md-6">
                  <p>
                    <span className="titleoffield">
                      Upload First Govt. ID Proof :{" "}
                    </span>
                    <span className="inputoffield">
                      <a
                        href={`${GLOBAL_URL}downloadfile/cmot/${formData.id}/${formData?.documentData?.[1]?.file}`}
                      >
                        <FileDownloadIcon /> {formData?.documentData?.[1]?.name}
                      </a>
                    </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield">
                      Second Govt. ID Number :{" "}
                    </span>
                    <span className="inputoffield">
                      {" "}
                      {formData.second_govt_id_number}
                    </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield">
                      Upload Second Govt. ID Proof :{" "}
                    </span>
                    <span className="inputoffield">
                      <a
                        href={`${GLOBAL_URL}downloadfile/cmot/${formData.id}/${formData?.documentData?.[2]?.file}`}
                      >
                        <FileDownloadIcon /> {formData?.documentData?.[2]?.name}
                      </a>
                    </span>
                  </p>
                </div>
              </div>
            </Container>
          </AccordionDetails>
        </Accordion>

        {/* Accordion for Films Details */}
        <Accordion
          expanded={expanded === "panel3"}
          onChange={handleChange("panel3")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3-content"
            id="panel3-header"
          >
            <button
              onClick={() => handleRedirectStep(2)}
              style={{
                background: "transparent",
                border: "none",
                marginRight: "20px",
                color: "#1c5768",
              }}
            >
              <BorderColorTwoToneIcon />
            </button>
            Films Details
          </AccordionSummary>
          <AccordionDetails>
            <Container maxWidth="lg">
              <div className="row">
                <div className="col-md-12">
                  <p>
                    <span className="titleoffield">Film Craft : </span>
                    <span className="inputoffield">
                      {" "}
                      {formData.category_id
                        ? craftData?.[formData.category_id]
                          ? craftData[formData.category_id]
                          : ""
                        : ""}{" "}
                      {/* {console.log("category_id", formData.category_id)} */}
                    </span>
                  </p>
                </div>
                {formData.category_id == 5 ? (
                  <div className="col-md-12">
                    <p>
                      <span className="titleoffield">Specialization : </span>
                      <span className="inputoffield">
                        {" "}
                        {formData.specialization}
                      </span>
                    </p>
                  </div>
                ) : (
                  ""
                )}
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield">
                      Link to Film and password:
                    </span>
                    <span className="inputoffield">
                      {" "}
                      {formData.link_of_film}
                    </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield">Link Film password :</span>
                    <span className="inputoffield">
                      {" "}
                      {formData.link_film_password}
                    </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield">
                      Project Title (Film/Audio Track/Portfolio) :
                    </span>
                    <span className="inputoffield">
                      {" "}
                      {formData.project_title}
                    </span>
                  </p>
                </div>

                <div className="col-md-6">
                  <p>
                    <span className="titleoffield">
                      Duration (In Minutes) :
                    </span>
                    <span className="inputoffield">
                      {formData.film_duration}
                    </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield">
                      Project Completion Date :
                    </span>
                    <span className="inputoffield">
                      {convertDateToIndianFormat(
                        formData.project_completion_date
                      )}
                    </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield">Upload CV :</span>
                    <span className="inputoffield">
                      <a
                        href={`${GLOBAL_URL}downloadfile/cmot/${formData.id}/${formData?.documentData?.[3]?.file}`}
                      >
                        <FileDownloadIcon /> {formData?.documentData?.[3]?.name}
                      </a>
                    </span>
                  </p>
                </div>
                <div className="col-md-6">
                  <p>
                    <span className="titleoffield">
                      Enter Filmography URL :
                    </span>
                    <span className="inputoffield">
                      {" "}
                      {formData.filmography_url}
                    </span>
                  </p>
                </div>
                <div className="col-md-12">
                  <p>
                    <span className="titleoffield">
                      Show reel (Format in Link) :
                    </span>
                    <span className="inputoffield">
                      {" "}
                      <a
                        href={`${GLOBAL_URL}downloadfile/cmot/${formData.id}/${formData?.documentData?.[4]?.file}`}
                      >
                        <FileDownloadIcon /> {formData?.documentData?.[4]?.name}
                      </a>
                    </span>
                  </p>
                </div>
                <Root>
                  <Divider>
                    <Chip label="Optional" size="small" />
                  </Divider>
                </Root>

                <div className="col-md-12">
                  <p>
                    <span className="titleoffield">
                      Awards/Recognition (If Any) :
                    </span>
                    <span className="inputoffield">
                      {" "}
                      {formData.awards_recognition}
                    </span>
                  </p>
                </div>
              </div>
            </Container>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  );
};

export default Preview;
